import { useNavigate, useParams } from "react-router-dom";
import CancelIcon from "../../assets/img/cancel-01.svg";
import UserIcon from "../../assets/img/user-icon.svg";
import useTranslator from "../../hooks/useTranslator";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import { haveValue } from "../../helper/common";
import LandLordContext from "../../context/landlord/LandLordContext";
import { toast } from "../../helper/common";

const ConfirmWorkspaceRemovalModal = ({ setOpenDeleteModal, onCloseMain }) => {
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const { workspaceId } = useParams();
  const { user, loadUserTenant } = useContext(AuthContext);
  const { deleteWorkspace } = useContext(LandLordContext);

  const [buttonDisable, setButtonDisable] = useState(false);

  const handleSubmitButton = () => {
    setButtonDisable(true);
    const sendData = {};
    deleteWorkspace(sendData)
      .then((res) => {
        loadUserTenant("landlord");
        navigate("/workspace-dashboard");
        toast.success(_t("workspaceRemovedSuccessfully"));
        onCloseMain();
      })
      .catch((err) => {
        console.log(err);
        toast.error(_t("errorWhileRemovingworkspace"));
      })
      .finally(() => {
        setButtonDisable(false);
      });
  };

  return (
    <div
      className="approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal confirmRemovalModalWrapper"
      style={{ zIndex: 1052 }}
    >
      <div className="popup-content2 popup-content bg-white guarantorDocuments confirmRemovalModal position-relative">
        <div className="d-flex flex-column">
          <div className="d-flex ps-0 gap-4 align-items-center justify-content-between">
            <div>
              <h4>{_t("deleteMyWorkspace")} </h4>
            </div>
            <div
              className="cursor-pointer"
              onClick={(e) => setOpenDeleteModal(false)}
            >
              <img
                src={CancelIcon}
                alt="icon"
                className="canceicon topRightIcon"
              />
            </div>
          </div>
          <p className="tenant-doc-text">
            {_t(
              "areYouSureWantToPermanentlyDeleteThisWorkspaceAllSharedProfilesPropertiesAndMembersWillAlsoBeDeleted"
            )}
          </p>
          <p className="remove-modal-workspace-name">
            {user?.workspaceIds?.find(
              (val) => val?.uuid?.toString() === workspaceId?.toString()
            )?.name ?? ""}
          </p>
        </div>
        <div className="d-flex align-items-center justify-content-center custom-gap-3 buttonWrapperDocument">
          <button
            type="button"
            className="btnNext btnnextpre"
            onClick={(e) => setOpenDeleteModal(false)}
            disabled={buttonDisable}
          >
            {_t("noGoBack")}
          </button>
          <button
            type="button"
            className="btnNext"
            onClick={handleSubmitButton}
            disabled={buttonDisable}
          >
            {_t("yesRemove")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmWorkspaceRemovalModal;
